module.exports = __webpack_public_path__ + "assets/aecb146b82fc97b1c7f00a3d3742e5f8.mp3";